import { useCallback, useState, lazy, Suspense } from 'react';
import { useToggle } from 'react-use';
import SimpleModal from 'components/SimpleModal';
import styled from 'styled-components';
import { useDynamicModal } from 'components/DynamicModalProvider/useDynamicModal';

const IntegrationSettings = lazy(() => import('IntegrationModule/components/Settings'));

type ModalProps = {
  targetServiceId: number;
  teamId: number;
};

const useIntegrationSettingsModal = () => {
  const { openModal } = useDynamicModal();

  const handleOpenIntegrationSettingsModal = useCallback(
    (modalProps: ModalProps) => {
      openModal({
        modal: ({ isOpen: _isOpen, toggle }) => {
          return (
            <Suspense fallback={<div />}>
              <SimpleModal
                height={850}
                width={900}
                Body={
                  <StyledBody>
                    <IntegrationSettings {...modalProps} />
                  </StyledBody>
                }
                open
                hideConfirmButton
                onClose={toggle}
              />
            </Suspense>
          );
        },
      });
    },
    [openModal],
  );

  return { handleOpenIntegrationSettingsModal };
};

export default useIntegrationSettingsModal;

const StyledBody = styled.div`
  .integration-settings-content {
    height: 650px;
    overflow: auto;
    padding: 24px;
  }
`;
